const { default: Swiper } = require('swiper');
const { Pagination } = require('swiper/modules');

const sections = document.querySelectorAll('section.apartment-slider');
if (sections.length) {
    sections.forEach(element => {
        const sliderEl = element.querySelector('.swiper-slider');
        const paginationEl = element.querySelector('[swiper-pagination]');
        if (sliderEl) {
            const swiper = new Swiper(sliderEl, {
                spaceBetween: 16,
                modules: [Pagination],
                pagination: {
                    el: paginationEl,
                    type: 'progressbar',
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.2,
                    },
                    1024: {
                        slidesPerView: 2.7,
                    },
                    1600: {
                        slidesPerView: 4,
                    },
                },
            });
        }
    });
}
